import { useRef, useEffect } from 'react';

type Previous<T, I> = I extends undefined ? T | undefined : T | I;

/**
 * Hook to cache the previous value passed.
 * @param {*} valueToUsePreviousOf
 * @example <caption>Example Usage</caption>
 * const previousVal = usePrevious(value, initialValue?);
 */
export default function usePrevious<T, I = undefined>(value: T, initialValue?: I): Previous<T, I> {
  const ref = useRef<T | I | undefined>(initialValue);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current as unknown as Previous<T, I>;
}
